import { color } from "emoreg/const";

export const labelColor = {
  grey: { color: color.grey.darker },
  blue: { color: color.blue.base },
};
